module.exports = __webpack_public_path__ + "assets/img/923030.44cdae68.jpg";